import _ax from './_ax';

export function sendDeposit(amount, payment_method) {
    return _ax.post('rechargev2', { amount, payment_method });
}
export function postDeposit(amount, type) {
    return _ax.post('deposit', { amount, type });
}
export function getWalletAddresss() {
    return _ax.get('walletAddress');
}